import Editor, {
    BtnBold,
    BtnItalic,
    BtnBulletList,
    createButton,
    Toolbar
  } from 'react-simple-wysiwyg';
  
  //const BtnAlignCenter = createButton('Align center', '≡', 'justifyCenter');
  //const BtnAlignLeft = createButton('Align left', '≡', 'justifyLeft');
  const BtnAlignLeft = createButton('Align left', 
    <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20">
      <path d="M3 3h18v2H3V3zm0 4h12v2H3V7zm0 4h18v2H3v-2zm0 4h12v2H3v-2zm0 4h18v2H3v-2z"/>
    </svg>,
    'justifyLeft'
  );
  
  const BtnAlignCenter = createButton('Align center', 
    <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20">
      <path d="M3 3h18v2H3V3zm4 4h10v2H7V7zm-4 4h18v2H3v-2zm4 4h10v2H7v-2zm-4 4h18v2H3v-2z"/>
    </svg>,
    'justifyCenter'
  );
  
  const BtnAlignRight = createButton('Align right', 
    <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20">
      <path d="M3 3h18v2H3V3zm6 4h12v2H9V7zm-6 4h18v2H3v-2zm6 4h12v2H9v-2zm-6 4h18v2H3v-2z"/>
    </svg>,
    'justifyRight'
  );

  
  export default function CustomEditor({ value, onChange,containerProps }) {
    return (
      <Editor
        value={value}
        onChange={onChange}
        containerProps={{
          ...containerProps,
          className: `${containerProps?.className || ''} text-black`,
          style: {
            color: '#000',
            ...(containerProps?.style || {})
          }
        }}
      >
        <Toolbar>
          <BtnBold />
          <BtnItalic />
          <BtnBulletList />
          <BtnAlignLeft />
          <BtnAlignCenter />
          <BtnAlignRight/>
        </Toolbar>
      </Editor>
    );
  }